export const ReorderDirection = { UP: "up", DOWN: "down" } as const;
export type ReorderDirectionType =
  (typeof ReorderDirection)[keyof typeof ReorderDirection];
